import { TenantEntity } from '../TenantEntity'

export class PoItems extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get orderNo() {
    return this._data.orderNo
  }
  set orderNo(orderNo) {
    this._data.orderNo = orderNo
  }
  get moduleCode() {
    return this._data.moduleCode
  }
  set moduleCode(moduleCode) {
    this._data.moduleCode = moduleCode
  }
  get caseNo() {
    return this._data.caseNo
  }
  set caseNo(caseNo) {
    this._data.caseNo = caseNo
  }
  get itemNo() {
    return this._data.itemNo
  }
  set itemNo(itemNo) {
    this._data.itemNo = itemNo
  }
  get subItemNo() {
    return this._data.subItemNo
  }
  set subItemNo(subItemNo) {
    this._data.subItemNo = subItemNo
  }
  get supplyPartNo() {
    return this._data.supplyPartNo
  }
  set supplyPartNo(supplyPartNo) {
    this._data.supplyPartNo = supplyPartNo
  }
  get orderPartNo() {
    return this._data.orderPartNo
  }
  set orderPartNo(orderPartNo) {
    this._data.orderPartNo = orderPartNo
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode
  }
  get chineseCommodity() {
    return this._data.chineseCommodity
  }
  set chineseCommodity(chineseCommodity) {
    this._data.chineseCommodity = chineseCommodity
  }
  get englishCommodity() {
    return this._data.englishCommodity
  }
  set englishCommodity(englishCommodity) {
    this._data.englishCommodity = englishCommodity
  }
  get customsCommodity() {
    return this._data.customsCommodity
  }
  set customsCommodity(customsCommodity) {
    this._data.customsCommodity = customsCommodity
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get grossWeight() {
    return this._data.grossWeight
  }
  set grossWeight(grossWeight) {
    this._data.grossWeight = grossWeight || 0.0
  }
  get orgRegion() {
    return this._data.orgRegion
  }
  set orgRegion(orgRegion) {
    this._data.orgRegion = orgRegion
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage || 0.0
  }
  get purchasePrice() {
    return this._data.purchasePrice
  }
  set purchasePrice(purchasePrice) {
    this._data.purchasePrice = purchasePrice || 0.0
  }
  get purchaseAmount() {
    return this._data.purchaseAmount
  }
  set purchaseAmount(purchaseAmount) {
    this._data.purchaseAmount = purchaseAmount || 0.0
  }
  get purchaseTariffRate() {
    return this._data.purchaseTariffRate
  }
  set purchaseTariffRate(purchaseTariffRate) {
    this._data.purchaseTariffRate = purchaseTariffRate || 0.0
  }
  get purchaseTariffAmount() {
    return this._data.purchaseTariffAmount
  }
  set purchaseTariffAmount(purchaseTariffAmount) {
    this._data.purchaseTariffAmount = purchaseTariffAmount || 0.0
  }
  get purchaseValRate() {
    return this._data.purchaseValRate
  }
  set purchaseValRate(purchaseValRate) {
    this._data.purchaseValRate = purchaseValRate || 0.0
  }
  get purchaseValAmount() {
    return this._data.purchaseValAmount
  }
  set purchaseValAmount(purchaseValAmount) {
    this._data.purchaseValAmount = purchaseValAmount || 0.0
  }
  get purchaseExciseRate() {
    return this._data.purchaseExciseRate
  }
  set purchaseExciseRate(purchaseExciseRate) {
    this._data.purchaseExciseRate = purchaseExciseRate || 0.0
  }
  get purchaseExciseAmount() {
    return this._data.purchaseExciseAmount
  }
  set purchaseExciseAmount(purchaseExciseAmount) {
    this._data.purchaseExciseAmount = purchaseExciseAmount || 0.0
  }
  get purchaseCurrency() {
    return this._data.purchaseCurrency
  }
  set purchaseCurrency(purchaseCurrency) {
    this._data.purchaseCurrency = purchaseCurrency
  }
  get pruchaseExchangeRate() {
    return this._data.pruchaseExchangeRate
  }
  set pruchaseExchangeRate(pruchaseExchangeRate) {
    this._data.pruchaseExchangeRate = pruchaseExchangeRate || 0.0
  }
  get sellPrice() {
    return this._data.sellPrice
  }
  set sellPrice(sellPrice) {
    this._data.sellPrice = sellPrice || 0.0
  }
  get sellAmount() {
    return this._data.sellAmount
  }
  set sellAmount(sellAmount) {
    this._data.sellAmount = sellAmount || 0.0
  }
  get sellValRate() {
    return this._data.sellValRate
  }
  set sellValRate(sellValRate) {
    this._data.sellValRate = sellValRate || 0.0
  }
  get sellValAmount() {
    return this._data.sellValAmount
  }
  set sellValAmount(sellValAmount) {
    this._data.sellValAmount = sellValAmount || 0.0
  }
  get customsBillSeq() {
    return this._data.customsBillSeq
  }
  set customsBillSeq(customsBillSeq) {
    this._data.customsBillSeq = customsBillSeq || 0.0
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get netWeight() {
    return this._data.netWeight
  }
  set netWeight(netWeight) {
    this._data.netWeight = netWeight || 0.0
  }
  get itemSpec() {
    return this._data.itemSpec
  }
  set itemSpec(itemSpec) {
    this._data.itemSpec = itemSpec
  }
  get measure() {
    return this._data.measure
  }
  set measure(measure) {
    this._data.measure = measure
  }
  get related() {
    return this._data.related
  }
  set related(related) {
    this._data.related = related || 0
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo
  }
  get eqType() {
    return this._data.eqType
  }
  set eqType(eqType) {
    this._data.eqType = eqType
  }
  get eqSize() {
    return this._data.eqSize
  }
  set eqSize(eqSize) {
    this._data.eqSize = eqSize
  }
  get sealNo() {
    return this._data.sealNo
  }
  set sealNo(sealNo) {
    this._data.sealNo = sealNo
  }
  get containerUsageKey() {
    return this._data.containerUsageKey
  }
  set containerUsageKey(containerUsageKey) {
    this._data.containerUsageKey = containerUsageKey
  }
  get psdCode() {
    return this._data.psdCode
  }
  set psdCode(psdCode) {
    this._data.psdCode = psdCode
  }
  get techChemName() {
    return this._data.techChemName
  }
  set techChemName(techChemName) {
    this._data.techChemName = techChemName
  }
  get imoSort() {
    return this._data.imoSort
  }
  set imoSort(imoSort) {
    this._data.imoSort = imoSort
  }
  get segGroup() {
    return this._data.segGroup
  }
  set segGroup(segGroup) {
    this._data.segGroup = segGroup
  }
  get caa() {
    return this._data.caa
  }
  set caa(caa) {
    this._data.caa = caa
  }
  get pih() {
    return this._data.pih
  }
  set pih(pih) {
    this._data.pih = pih || false
  }
  get reportableQty() {
    return this._data.reportableQty
  }
  set reportableQty(reportableQty) {
    this._data.reportableQty = reportableQty || false
  }
  get emerTemp() {
    return this._data.emerTemp
  }
  set emerTemp(emerTemp) {
    this._data.emerTemp = emerTemp || 0.0
  }
  get mpCode() {
    return this._data.mpCode
  }
  set mpCode(mpCode) {
    this._data.mpCode = mpCode
  }
  get controlTemp() {
    return this._data.controlTemp
  }
  set controlTemp(controlTemp) {
    this._data.controlTemp = controlTemp || 0.0
  }
  get density() {
    return this._data.density
  }
  set density(density) {
    this._data.density = density || 0.0
  }
  get imdgFrom() {
    return this._data.imdgFrom
  }
  set imdgFrom(imdgFrom) {
    this._data.imdgFrom = imdgFrom
  }
  get imdgTo() {
    return this._data.imdgTo
  }
  set imdgTo(imdgTo) {
    this._data.imdgTo = imdgTo
  }
  get marPollutant() {
    return this._data.marPollutant
  }
  set marPollutant(marPollutant) {
    this._data.marPollutant = marPollutant
  }
  get flashPoint() {
    return this._data.flashPoint
  }
  set flashPoint(flashPoint) {
    this._data.flashPoint = flashPoint || 0.0
  }
  get dcPackage() {
    return this._data.dcPackage
  }
  set dcPackage(dcPackage) {
    this._data.dcPackage = dcPackage
  }
  get dcPackaging() {
    return this._data.dcPackaging
  }
  set dcPackaging(dcPackaging) {
    this._data.dcPackaging = dcPackaging
  }
  get dcWeight() {
    return this._data.dcWeight
  }
  set dcWeight(dcWeight) {
    this._data.dcWeight = dcWeight || 0.0
  }
  get quterQty() {
    return this._data.quterQty
  }
  set quterQty(quterQty) {
    this._data.quterQty = quterQty || 0
  }
  get innerPackage() {
    return this._data.innerPackage
  }
  set innerPackage(innerPackage) {
    this._data.innerPackage = innerPackage
  }
  get innerQty() {
    return this._data.innerQty
  }
  set innerQty(innerQty) {
    this._data.innerQty = innerQty || 0
  }
  get emerProvider() {
    return this._data.emerProvider
  }
  set emerProvider(emerProvider) {
    this._data.emerProvider = emerProvider
  }
  get contactName() {
    return this._data.contactName
  }
  set contactName(contactName) {
    this._data.contactName = contactName
  }
  get emerPhone() {
    return this._data.emerPhone
  }
  set emerPhone(emerPhone) {
    this._data.emerPhone = emerPhone
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get ediContainerUuid() {
    return this._data.ediContainerUuid
  }
  set ediContainerUuid(ediContainerUuid) {
    this._data.ediContainerUuid = ediContainerUuid
  }
  get customerId() {
    return this._data.customerId
  }
  set customerId(customerId) {
    this._data.customerId = customerId
  }

  get mark() {
    return this._data.mark
  }
  set mark(mark) {
    this._data.mark = mark
  }

  get packing() {
    return this._data.packing
  }
  set packing(packing) {
    this._data.packing = packing
  }

  get serialNumber() {
    return this._data.serialNumber
  }
  set serialNumber(serialNumber) {
    this._data.serialNumber = serialNumber
  }

  get brand() {
    return this._data.brand
  }
  set brand(brand) {
    this._data.brand = brand
  }

  get productiveYear() {
    return this._data.productiveYear
  }
  set productiveYear(productiveYear) {
    this._data.productiveYear = productiveYear
  }

  get customsValue() {
    return this._data.customsValue
  }
  set customsValue(customsValue) {
    this._data.customsValue = customsValue
  }

  get unitType() {
    return this._data.unitType
  }
  set unitType(unitType) {
    this._data.unitType = unitType
  }

  get deviceType() {
    return this._data.deviceType
  }
  set deviceType(deviceType) {
    this._data.deviceType = deviceType
  }

  get countryOrigin() {
    return this._data.countryOrigin
  }
  set countryOrigin(countryOrigin) {
    this._data.countryOrigin = countryOrigin
  }

  get deviceStatus() {
    return this._data.deviceStatus
  }
  set deviceStatus(deviceStatus) {
    this._data.deviceStatus = deviceStatus
  }

  get sequenceNo() {
    return this._data.sequenceNo
  }
  set sequenceNo(sequenceNo) {
    this._data.deviceStatus = sequenceNo || 0
  }

  get lengthCm() {
    return this._data.lengthCm
  }
  set lengthCm(lengthCm) {
    this._data.lengthCm = lengthCm
  }

  get weightCm() {
    return this._data.weightCm
  }
  set weightCm(weightCm) {
    this._data.weightCm = weightCm
  }

  get heigthCm() {
    return this._data.heigthCm
  }
  set heigthCm(heigthCm) {
    this._data.heigthCm = heigthCm
  }

  get cargoText() {
    return this._data.cargoText
  }
  set cargoText(cargoText) {
    this._data.cargoText = cargoText
  }

  get newOrUsed() {
    return this._data.newOrUsed
  }
  set newOrUsed(newOrUsed) {
    this._data.newOrUsed = newOrUsed
  }

  get propulsionType() {
    return this._data.propulsionType
  }
  set propulsionType(propulsionType) {
    this._data.propulsionType = propulsionType
  }
  get packingName() {
    return this._data.packingName
  }
  set packingName(packingName) {
    this._data.packingName = packingName
  }
  get ncmNo() {
    return this._data.ncmNo
  }
  set ncmNo(ncmNo) {
    this._data.ncmNo = ncmNo
  }
  get sendStatus() {
    return this._data.sendStatus
  }
  set sendStatus(sendStatus) {
    this._data.sendStatus = sendStatus
  }
  get sendingTime() {
    return this._data.sendingTime
  }
  set sendingTime(sendingTime) {
    this._data.sendingTime = sendingTime
  }
  get sender() {
    return this._data.sender
  }
  set sender(sender) {
    this._data.sender = sender
  }
  get thirdPartyId() {
    return this._data.thirdPartyId
  }
  set thirdPartyId(thirdPartyId) {
    this._data.thirdPartyId = thirdPartyId
  }
  get cargoType() {
    return this._data.cargoType
  }
  set cargoType(cargoType) {
    this._data.cargoType = cargoType
  }
  get billingQty() {
    return this._data.billingQty
  }
  set billingQty(billingQty) {
    this._data.billingQty = billingQty
  }
  get invoiceNo() {
    return this._data.invoiceNo
  }
  set invoiceNo(invoiceNo) {
    this._data.invoiceNo = invoiceNo
  }
}
